import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NavItemPrimaryInterface } from 'app/app-layout/models';
import { AuthService } from 'app/core/authentication/services';
import { environment } from 'environments/environment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'cz-sidenav-primary',
  templateUrl: './sidenav-primary.component.html',
  styleUrls: ['./sidenav-primary.component.scss'],
})
export class SidenavPrimaryComponent {

  public adminToken: SafeUrl;
  public url: any;
  @Input() public readonly navItems$: NavItemPrimaryInterface[];
  @Input() public readonly isDefaultUser: boolean;
  @Input() public readonly isAdminsite: boolean;


  constructor(
    public readonly route: Router,
    private readonly _authService: AuthService,
    _sanitizer: DomSanitizer) {
    if(!this.isDefaultUser) {
      this._authService.getJwt().pipe(take(1)).subscribe((token: string) => {
        const host: string = environment.production ? 'https://admin' + window.location.hostname + '/' : 'http://localhost:10220/';
        this.adminToken = _sanitizer.bypassSecurityTrustUrl(host + '/login/loginfromclient/?token=' + token);
        this.url = host + '/login/loginfromclient/?token=' + token;
      });
    }
  }

  public openUrl() {
    const mywindow = window.open(this.url, '_blank');
    this._authService.setAdminSiteWindow(mywindow);
  }

}
